<template>
  <div class="card shadow mb-4">
    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
      <h6 class="m-0 font-weight-bold">{{ $t('Consumption') }}</h6>
      <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="$t('ev_tooltip_consumption')"></i>
    </div>
    <div class="card-body text-center">
      <div id="canvas-evchart"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'EVChart',
  data() {
    return {
      chart: null,
    }
  }, 
  mounted: function(){
    const chart_options = {
      chart: {
        zoomType: '',
        backgroundColor: '#fff',
        type: 'spline'
      },
      title: {
        text: null
      },
      credits: { enabled: false },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
            day: '%a, %e %b'
        }
      },
      yAxis: {
        title: {
            text: ''
        }
      },
      legend: {
        enabled: true
      },
      tooltip: {
        shared: true,
        xDateFormat: '%A, %d %b, %H:%M',
        pointFormat: '<br/><span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.y}</b> W'
      },
      plotOptions: {
        events: {
          legendItemClick: function () {
            if (this.visible) _paq.push(['trackEvent', 'Geral', 'Gráfico EV', 'Esconder (' + this.name + ')'])                        
            else _paq.push(['trackEvent', 'Geral', 'Gráfico EV', 'Mostrar (' + this.name + ')'])
          },
          mouseOver: function () {
            self.clock = setInterval(function(){ self.sec++; }, 1000)
          },
          mouseOut: function () {
            clearInterval(self.clock);
            if (self.sec > 1) _paq.push(['trackEvent', 'Geral', 'Gráfico EV', 'MouseOver (' + this.name + ')', self.sec])
            self.sec = 0
          }
        },
        /* area: {
          stacking: 'normal',
          marker: {
            radius: 2
          },
          lineWidth: 1,
          states: {
            hover: {
              lineWidth: 1
            }
          },
          threshold: 0
        }, */
        series: {
          connectNulls: false,
          marker: {
            enabled: false
          }
        },
      },
      series: []
    }

    this.chart = Highcharts.chart('canvas-evchart', chart_options)
  },
  methods: {
    set_values: function(){
      if (this.data.length == 0) return
      const timezone = this.$store.getters.timezone
      if (this.chart.series.length != this.data.length){
        while (this.chart.series.length > 0) this.chart.series[0].remove(true);
        let index = 0
        this.data.forEach(d => {
          this.chart.addSeries({
            name: this.$i18n.t('Station')+" "+d.device.ev.number,
            type: 'spline',
            color: this.colors[index],
            visible: d.data.summaryChart && d.data.summaryChart.length ? true : false,
            //data: d.data.summaryChart && d.data.summaryChart.map(s => [moment.tz(s.datetime, timezone).valueOf(), Math.round(s.consumption)]),
            data: d.data.summaryChart && d.data.summaryChart.map(s => [moment.tz(s.datetime, timezone).valueOf(), Math.round(s.House)]),
          }, false)
          index++
        })
      }
      else {
        let index = 0
        this.data.forEach(d => {
          //this.chart.series[index].setData(d.data.summaryChart && d.data.summaryChart.map(r => [moment.tz(r.datetime, timezone).valueOf(), Math.round(r.consumption)]), false)
          this.chart.series[index].setData(d.data.summaryChart && d.data.summaryChart.map(r => [moment.tz(r.datetime, timezone).valueOf(), Math.round(r.House)]), false)
          this.chart.series[index].update({ visible: d.data.summaryChart && d.data.summaryChart.length ? true : false }) 
          this.chart.series[index].update({ name:this.$i18n.t('Station')+" "+d.device.ev.number })
          index++
        })
      }
      
      if(!this.chart.hasData()){
        this.chart.hideNoData()
        this.chart.showNoData(this.$i18n.t('No_Data'))
      }
      this.chart.series.sort((a,b) => a.name > b.name)
      this.chart.redraw() 
    },
  },
  computed:{
    colors: function(){
      return this.$store.getters.ev_colors
    },
    data: function(){
      return this.$store.getters.data //this.$store.getters.data_ev
    },
    loading: function(){
      return this.$store.getters.data_loading
    },
    current_lang: function(){
      return this.$i18n.locale
    }
  },
  watch:{
    data: function(){
      this.set_values()
    },
    current_lang: function(){
      return this.set_values()
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
